"use client";

import type { PropsWithChildren } from "react";

import { ReactQueryProvider } from "@/providers/react-query-provider";

import { ClientChakraProvider } from "@flowpos-workspace/frontend-theme/chakra/provider.chakra";

export const GlobalProviders = ({ children }: PropsWithChildren) => (
	<ReactQueryProvider>
		<ClientChakraProvider>{children}</ClientChakraProvider>
	</ReactQueryProvider>
);
